module.exports = __webpack_public_path__ + "img/gov-smes-full.8ba92697.png";